module.exports = __webpack_public_path__ + "assets/img/normal-seasun-logo-9ec6b8e8.png";